































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { Size } from '@front-app/components/constants';
import { InviteeStatus } from '@front-app/services/GroupInvitationCampaignApi/model';

export default defineComponent({
	props: {
		status: {
			type: String as PropType<InviteeStatus>,
			required: true,
		},
		size: {
			type: String as PropType<Size>,
			default: Size.TINY,
		},
	},
	setup(props) {
		const classes = computed(() => ({
			'badge--tiny': props.size === Size.TINY,
			'badge--medium': props.size === Size.MEDIUM,
		}));
		return {
			InviteeStatus,
			classes,
		};
	},
});
